export const ItalicSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1159 0.506348H8.69656C7.83375 0.506348 7.13406 1.20604 7.13406 2.06885C7.13406 2.93166 7.83375 3.63135 8.69656 3.63135H9.70188L7.06094 16.3423C7.05906 16.3513 7.06 16.3598 7.05844 16.3688H5.88406C5.02125 16.3688 4.32156 17.0682 4.32156 17.9313C4.32156 18.7945 5.02125 19.4938 5.88406 19.4938H11.3034C12.1666 19.4938 12.8659 18.7945 12.8659 17.9313C12.8659 17.0682 12.1666 16.3688 11.3034 16.3688H10.2413L12.8872 3.63135H14.1159C14.9791 3.63135 15.6784 2.93166 15.6784 2.06885C15.6784 1.20604 14.9791 0.506348 14.1159 0.506348Z"
      fill="currentColor"
    />
  </svg>
);
